import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconPlus: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconPlus" {...props}>
    <svg height="100%" viewBox="0 0 32 32" fill="currentColor">
      <path d="M29.7188 15.2812C29.5 15.0938 29.2812 15 29 15H17V3c0-.28125-.0938-.5-.2812-.71875C16.5 2.09375 16.2812 2 16 2s-.5.09375-.6875.28125C15.0938 2.5 15 2.71875 15 3v12H3c-.28125 0-.5.0938-.6875.2812C2.09375 15.5 2 15.7188 2 16s.09375.5.3125.6875C2.5 16.9062 2.71875 17 3 17h12v12c0 .2812.0938.5.3125.6875.1875.2187.4063.3125.6875.3125s.5-.0938.7188-.3125C16.9062 29.5 17 29.2812 17 29V17h12c.2812 0 .5-.0938.7188-.3125C29.9062 16.5 30 16.2812 30 16s-.0938-.5-.2812-.7188Z" />
    </svg>
  </IconSVG>
)
